// extracted by mini-css-extract-plugin
module.exports = {"viewMoreButton":"ViewMoreButton_viewMoreButton__1mRfJ"};